<template>
    <div >
        <x-grid :id="'formList'"
                :rowId="rowId"
                :pager-config="pagerConfig"
                :form-config="formConfig"
                :url="url"
                :columns="columns"
                :checkbox-config="checkboxConfig"
                :print-config="printConfig"
                :export-config="exportConfig"
                ref="grid"
                :cellClick="chooseRow"
                :cellDbClick="updateRow"
                @toolbar-addData="addRow"
                @toolbar-delData="delRow"
                :otherParams="{'filter.orderByDesc.createTime':true, 'filter.eq.jobId': jobId}"
        >
            <template v-slot:[toolbarConfig.templatelSlots]>
            </template>
        </x-grid>
        <a-space class="a-form-btn-box">
            <a-button @click="endEdit()">取消</a-button>
        </a-space>
    </div>
</template>

<script>
  import XGrid from '@/components/grid/XGrid';
  import {GridMixin} from "@/utils/GridMixin";
  import {
    formatter as fmt
  } from "@/utils/ebase-formatter";
  import api from '@/services/api';
  import {loadBaseCodeData} from "@/services/baseCodeSource";

  console.info(fmt, loadBaseCodeData);//防止未用到报未定义错误 用到了可删除

  // import {dataApi} from '@/services/comm/userManage';
  // console.log(dataApi)

  //弹出层组件
  import {mapState} from "vuex";

  //接口api
  // import {dataApi} from '@/services/comm/timedTask';


  const fac = XGrid.factory;

  //列表接口
  const url = api.comm.SCHEDULELOG;
  const STATUSARR = {
    "0": "成功",
    "1": "失败",
  };
  function formatStatus({cellValue}) {
    let s = STATUSARR[String(cellValue).toUpperCase()];
    return s || "-";
  }

  //主键
  const rowId = 'logId';

  //列
  const columns = [
    fac.makeColumn("beanName", "bean名称", 150),
    fac.makeColumn("methodName", "方法名称", 100,'center'),
    fac.makeColumn({
      field: "params",
      title: "参数",
      width: 320,
      scrollY: {enabled: false}
    }),
    fac.makeColumn({
      field: "status",
      title: "状态",
      width: 100,
      align: 'center',
      formatter: formatStatus
    }),
    fac.makeColumn("error", "信息", 360, 'center'),
    fac.makeColumn("times", "耗时(单位：毫秒)", 100, 'center'),
    fac.makeColumn("createTime", "执行时间", 160, 'center'),
  ]


  // 筛选条件
  const formConfig = fac.makeFormConfig(columns, [
    {field: 'beanName'},
    {field: 'params'},
  ])


  //工具栏按钮
  const toolbarConfig = fac.makeToolbarConfig({
    export: false,
    import: false,
    delData: false,
    addData: false,
    templatelSlots: 'toolbarBtns'
  });

  //可编辑表格约束
  const editRules = fac.makeEditRules(columns);
  const printConfig = fac.makePrintConfig(columns);
  const pagerConfig = fac.makePagerConfig();
  const checkboxConfig = fac.makeCheckboxConfig(columns);

  const popConfig = fac.makePopConfig(['password']);

  export default {
    mixins: [GridMixin],
    props: ['jobId'],
    authorize: {
      // addRow: "ADD",
      // updateRow: 'UPDATE',
      // delRow: 'DELETE',
      // importMethod:'IMPORT',
      // exportMethod:'EXPORT',
    },
    components: {},
    computed: {
      ...mapState('account', {currUser: 'user'}),
    },
    data() {
      return {
        popConfig,
        columns,
        rowId,
        url,
        formConfig,
        toolbarConfig,
        printConfig,
        checkboxConfig,
        editRules,
        pagerConfig,
      }
    },
    methods: {
      endEdit() {
        this.$emit('cancelled')
      }
    }
  }
</script>

<style scoped>
</style>
